var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8356 8.50207C16.8356 8.58099 16.8132 8.6583 16.7709 8.72498C16.7287 8.79167 16.6684 8.84499 16.5971 8.87873L1.59705 15.9621C1.52213 15.9984 1.43802 16.0113 1.35565 15.9992C1.27327 15.9871 1.19645 15.9505 1.13515 15.8941C1.07386 15.8378 1.03093 15.7643 1.01195 15.6832C0.992973 15.6022 0.998815 15.5173 1.02872 15.4396L3.39705 9.08373C3.53678 8.70854 3.53678 8.29559 3.39705 7.9204L1.02789 1.56456C0.99783 1.48677 0.991911 1.40172 1.0109 1.32051C1.02989 1.23929 1.07291 1.16569 1.13435 1.10929C1.19579 1.05288 1.2728 1.0163 1.35534 1.00431C1.43787 0.992321 1.52211 1.00548 1.59705 1.04206L16.5971 8.1254C16.6684 8.15914 16.7287 8.21246 16.7709 8.27915C16.8132 8.34583 16.8356 8.42314 16.8356 8.50207ZM16.8356 8.50207L3.50244 8.50244",
    stroke: "#448A7B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.bcb62a4d0ba6883818d2b42f60c85079.svg";
export { ForwardRef as ReactComponent };